import { render, staticRenderFns } from "./TextInputError.vue?vue&type=template&id=8cfae70c&lang=pug"
import script from "./TextInputError.vue?vue&type=script&lang=ts"
export * from "./TextInputError.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/app/components/vantone/Icon.vue').default})
